<script>
    import LoadingAnim from "./loadingAnim.svelte";
    import SlideshowModal from './slideshowModal.svelte';
    let showSlideshow = false;
    let slideshowImages = [];
    let currentSlideshowImage = {};
    let currentSlideshowImageID = null;

    import { operationStore, query } from '@urql/svelte';
    const getMyChoiceContent = operationStore(`
    {
      myChoice: entry(section: "pages", slug: "mychoice") {
        id
        title
        ... on myChoice_Entry {
          description
          myChoices: myChoice {
            ... on choice_Entry {
              image {
                id
                gridViewUrl: url @transform(width: 1300, format: "webp")
                detailViewUrl: url @transform(handle: "detail", immediately: true)
                ... on airplanes_Asset {
                  airplaneCategories: airplaneCategory {
                    id
                    title
                    category: parent {
                      id
                      title
                    }
                  }
                  countries: country {
                    id
                    title
                  }
                  registrations: registration {
                    id
                    title
                  }
                  capturePlace {
                    id
                    title
                  }
                  airlineOperators: airlineOperator {
                    id
                    title
                  }
                  captureDate @formatDateTime (format: "Y-m-d", timezone: "Europe/Zurich")
                  specialPaint
                  doubleSeater
                  flares
                  afterburner
                  landingGear
                  breakParachute
                  waterPlane
                  static
                  military
                }
              }
            description
          }
        }
      }
    }
  }`);
    query(getMyChoiceContent);
    getMyChoiceContent.subscribe(query => {
        if(!query.fetching && query.error === undefined) {
            query.data.myChoice.myChoices.forEach(choice => {
                slideshowImages.push(choice.image[0]);
            })
        }
    });

    function onImageClick() {
        currentSlideshowImageID = this.dataset.id;
        currentSlideshowImage = slideshowImages.find( ({ id }) => id === currentSlideshowImageID );
        showSlideshow = true;
    }
</script>
<main class="content mychoice">
    <h1>MyChoice</h1>
    {#if $getMyChoiceContent.fetching}
        <LoadingAnim/>
    {:else if $getMyChoiceContent.error}
        <p>Oh no... {$getMyChoiceContent.error.message}</p>
    {:else}
        {#if $getMyChoiceContent.data.myChoice.description !== null}
            <div class="jetnoise-grid description-holder">
                <div class="description">
                    {@html $getMyChoiceContent.data.myChoice.description}
                </div>
            </div>
        {/if}
        {#each $getMyChoiceContent.data.myChoice.myChoices as choice}
            <div class="jetnoise-grid choice">
                <img class="choice-image" src="{choice.image[0].gridViewUrl}" alt="{choice.image[0].title}" data-id="{choice.image[0].id}" on:click={onImageClick}>
                <div class="choice-text">
                    {@html choice.description}
                </div>
            </div>
        {/each}
    {/if}
    <SlideshowModal bind:open={showSlideshow} bind:currentSlideshowImageID={currentSlideshowImageID} bind:currentSlideshowImage={currentSlideshowImage} bind:slideshowImages={slideshowImages} />
</main>
<style lang="scss">
    img {
      width: 100%;
      box-shadow: var(--box-shadow);
      cursor: pointer;
    }
    .choice-text, .description {
      background-color: var(--background);
      padding: var(--default-padding);
      box-shadow: var(--box-shadow);
      height: fit-content;
    }
    .choice {
      margin-bottom: var(--large-margin);
    }
    .description-holder {
      margin-bottom: calc(var(--large-margin) * 1.5);
    }
    @media screen and (max-width: 1040px) {
      .jetnoise-grid {
        grid-template-columns: repeat(1, 1fr);
      }
    }
    @media screen and (min-width: 1040px) {
      .choice-image, .description {
        grid-column: 1 / span 2;
      }
    }
</style>